import styled, { css } from 'styled-components'
import { containerExpanded } from '../../../lib/styles/Container'
import { typoHeading6 } from '../../../lib/styles/Typography'

const Css = {
  Divider: css`
    --height: 0.9rem;
    content: '';
    display: block;
    width: 1px;
    height: var(--height);
    background-color: ${({ theme }) => theme.colors.black[5]};
    position: absolute;
    right: 0;
    top: calc(50% - (var(--height) / 2));
    z-index: -1;
  `,
}

export const Styled = {
  Footer: styled.footer`
    ${containerExpanded}
    margin: 0 auto;
    margin-top: 10rem;
    margin-bottom: 2rem;
  `,

  Nav: styled.div`
    margin-bottom: 3rem;
    display: grid;
    grid-template-columns: repeat(6, auto);
    row-gap: 3rem;
    column-gap: 1rem;
    justify-content: space-between;

    @media screen and (max-width: 1080px) {
      grid-template-columns: repeat(3, auto);
    }

    @media screen and (max-width: 576px) {
      grid-template-columns: repeat(2, auto);
    }
  `,

  NavItem: styled.div``,

  NavItemHeadline: styled.h6`
    ${typoHeading6}
    padding: 0.5rem 0.8rem;
  `,

  NavItemList: styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      margin: 0;
      padding: 0;
    }
  `,

  NavItemListItem: styled.li``,

  Search: styled.div`
    margin: 0 0.8rem 1.5rem 0.8rem;

    // Temporarily placeholder styles
    border-radius: 0.6rem;
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
    border: solid 1px ${({ theme }) => theme.colors.black[5]};
    color: ${({ theme }) => theme.colors.black[4]};
  `,

  Closure: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    row-gap: 1.5rem;
    column-gap: 1rem;
    flex-wrap: wrap;

    @media screen and (max-width: 1400px) {
    }
  `,

  ClosureNav: styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex: 0 1 auto;

    li {
      margin: 0;
    }

    > :first-child {
      padding: 0.5rem 0.8rem;
      font-size: 0.85rem;
      line-height: 1.1;
      font-weight: 600;
    }

    @media screen and (max-width: 1080px) {
      flex-wrap: wrap;
    }
  `,

  ClosureNavItem: styled.li`
    position: relative;
    padding: 0 0.5rem;

    &:not(:last-child):after {
      ${Css.Divider}
    }
  `,

  ClosureLast: styled.div`
    display: flex;
    flex: 0 1 auto;
  `,

  ClosureLastSocials: styled.ul`
    position: relative;
    margin: 0;
    list-style: none;
    display: flex;
    padding: 0;
    padding-right: 0.5rem;

    li {
      margin: 0;
      padding: 0;
    }

    &:not(:last-child)&:after {
      ${Css.Divider}
    }
  `,

  ClosureLastSocialsItem: styled.li`
    padding: 0;
    padding-left: 0.5rem;
  `,

  Language: styled.div`
    position: relative;
    padding-left: 0.5rem;
  `,

  LanguageDropdown: styled.div<{ show: boolean }>`
    position: absolute;
    bottom: calc(100% + 0.7rem);
    display: flex;
    flex-direction: column;
    right: 0;
    background: white;
    padding: 0.5rem;
    border-radius: 0.5rem;
    box-shadow: 0px 20px 220px -10px rgba(0, 0, 0, 0.1), 0px 12.3603px 90.1397px rgba(0, 0, 0, 0.0325794),
      0px 5.13384px 37.4394px rgba(0, 0, 0, 0.025), 0px 1.85681px 13.5411px rgba(0, 0, 0, 0.0174206);

    transition: opacity 0.1s ease-out;
    opacity: ${({ show }) => (show ? '1' : '0')};
    z-index: ${({ show }) => (show ? '1' : '-1')};
  `,
}
